<template>
    <div>
        <CRow class="ml-2 mt-5 mb-2 font-bold">Изображения</CRow>
        <div class="custom__grid">  
            <div
                v-for="item in pictures"
                :key="item.id"
                class="flex items-center custom__card"
            >
                <img
                    :src="pictureUrl(item.picture)"
                    alt="Промо обложка"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PromoCovers',

        props: {
            pictures: {
                type: Array,
                default: () => []
            }
        },

        computed: {},

        watch: {},
        mounted() {
        },

        methods: {
            pictureUrl(url) {
                return process.env.VUE_APP_STATIC_BASE_URL + '/' + url;
            },
        }
    }
</script>
<style scoped lang="scss">
.custom__grid {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.custom__card {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 24%;
    height: 140px;
    margin-right: 11px;
    margin-bottom: 11px;

    position: relative;

    border: 2px solid #e2e8f0;
    border-radius: 5px;
    overflow: hidden;

    img {
        display: block;
        width: 100%;
        max-width: 100%;
    }

    &:nth-child(4n) {
        margin-right: 0;
    }
}

@media (max-width: 514px) {
    .custom__card {
        width: 48%;
        &:nth-child(2n) {
            margin-right: 0;
        }
    }
}
</style>
